export const updateStore = {
  methods: {
    updateStore (key, value, page) {
      var payload= {
        key: key,
        value: value
      }
      this.$store.commit('SET_VALID', page)
      this.$store.commit('UPDATE_STORE', payload)
    }
  }
}
